import { useState } from 'react';
import {useDispatch, useSelector} from "react-redux";
import ResultSearch from './result_search';
import IndicadoresGeneral from './indicadores';
import SearchTickets from './search_tickets';
import {getTicketsD} from "../../../../app/store/fuse/reportes-tickets";

const Index = () => {
  const dispatch = useDispatch();
  const [filters, setFilters] = useState({
    criticidadTicket: 0,
    tipoFalla: 0,
    ticketStatus: 0,
    tipoTicket: 0,
    tipoRequerimiento: 0,
    numReporteSoc: "",
    numReporteBestel: "",
  });
  const initTickets = () => dispatch(getTicketsD(filters));

  const darkMode = useSelector((state) => state?.fuse?.dashboard?.darkMode);
  
  
  return (
    <>
      <div className="flex-col m-10 rounded-lg mt-0" style={{ backgroundColor: darkMode ? 'rgb(17, 24, 39)' : 'white' }}>
        <IndicadoresGeneral />
      </div>
      <div className="flex-col m-10 rounded-lg mt-0" style={{ backgroundColor: darkMode ? 'rgb(17, 24, 39)' : 'white' }}>
        <SearchTickets filters={filters} actualizarFiltros={setFilters} initTickets={initTickets} />
      </div>
      <div className="flex-colm-10 rounded-lg mt-0" style={{ backgroundColor: darkMode ? 'rgb(17, 24, 39)' : 'white' }}>
        <ResultSearch filters={filters} actualizarFiltros={setFilters} initTickets={initTickets} />
      </div>
    </>
  );
};

export default Index;
